import { DirectoryEntry } from '@missionlabs/types'
import { useMemo } from 'react'
import { useContactNumbersDropdown } from 'shared/hooks/useContactNumbersDropdown'
import { useFormatToNumberE164 } from 'shared/hooks/useFormatToNumberE164'

/**
 * Get a list of numbers that can be replied to
 * @returns list of numbers
 */
export const useGetActivityContactNumberOptions = (
    contact?: DirectoryEntry,
    contactNumber?: string
) => {
    const { formatToLocalNumber } = useFormatToNumberE164()

    const contactMobileNumbers = useContactNumbersDropdown({ contact, mobileOnly: false })

    const numbers = useMemo(() => {
        return contactNumber
            ? [{ value: contactNumber, label: formatToLocalNumber(contactNumber) }]
            : contactMobileNumbers.map(number => ({
                  label: number.label,
                  value: number.value
              }))
    }, [contactMobileNumbers, contactNumber, formatToLocalNumber])
    return numbers
}
